export default "__VITE_ASSET__Cu15C1ed__"